var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.countNodosActivos)?_c('div',{key:"emptyContent"},[_c('MoleculeEditionAssetContentEmpty')],1):_c('div',{key:"loadedContent"},[_c('MoleculeContentNode'),_c('MoleculeEditionAssetContentComments')],1)}
var staticRenderFns = []

export { render, staticRenderFns }